import {
  GrowthBook,
  GrowthBookProvider
} from '@growthbook/growthbook-react';
import React, { useEffect } from 'react';

// Create a GrowthBook instance
const gb = new GrowthBook({
  attributes: { role: 'student' },
  apiHost: process.env.GROWTH_BOOK_API_HOST,
  clientKey: process.env.GROWTH_BOOK_CLIENT_KEY,
  // Enable easier debugging during development
  enableDevMode: (process.env.environment !== 'prod_row'),
  // Disable background streaming connection
  backgroundSync: false,
  subscribeToChanges: false,
  // Only required for A/B testing
  // Called every time a user is put into an experiment
  trackingCallback: (
    experiment,
    result
  ) => {
    const gbAttributes = gb.getAttributes();

    if (gbAttributes && Object.keys(gbAttributes).length) {
      // https://docs.growthbook.io/guide/GA4-google-analytics

      // This part is responsibility of WSE since Google Analytics and Growth Book are managed by business and exact labels are their for they to decide
      if ('dataLayer' in window) {
        (window.dataLayer).push({ 
          event: 'experiment_viewed',
          user_id: gbAttributes.id,
          experiment_id: experiment.key,
          variation_id: `${result.variationId}`
        });
      }
    }
  }
});

window._growthbook = gb;

export const GrowthbookProvider = (props) => {
  const user = (() => {
    try {
      const data = localStorage.getItem('UserState');
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  })();

  useEffect(() => {
    if (user && user?.userId) {
      // TODO: set other attributes when needed
      gb.setAttributes({
        id: user.userId,
        userId: user.userId,
        ssdsId: user.userId
      });
    }
  }, [user]);

  useEffect(() => {
    // Load features from the GrowthBook API
    gb.init();
  }, []);
  return (
    <GrowthBookProvider growthbook={gb}>{props.children}</GrowthBookProvider>
  );
};
